'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = clientMiddleware;

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _jsBase = require('js-base64');

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pendingActionsLog = [];
var isGettingNewToken = false;

function clientMiddleware(_client) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;

    return function (next) {
      return function (action) {
        var promise = action.promise,
            types = action.types,
            rest = (0, _objectWithoutProperties3.default)(action, ['promise', 'types']);

        if (!promise) {
          return next(action);
        }

        var _types = (0, _slicedToArray3.default)(types, 3),
            REQUEST = _types[0],
            SUCCESS = _types[1],
            FAILURE = _types[2];

        next((0, _extends3.default)({}, rest, { type: REQUEST }));

        if (isGettingNewToken) {
          pendingActionsLog.push(action);
          return _bluebird2.default.resolve();
        }

        var client = _client(getState().auth && getState().auth.token);
        var actionPromise = promise(client);
        actionPromise.then(function (result) {
          next((0, _extends3.default)({}, rest, { result: result, type: SUCCESS }));

          // just got new token
          if (result && result.token) {
            isGettingNewToken = false;

            // drain the pending actions log now that we have a new token
            while (pendingActionsLog.length) {
              dispatch(pendingActionsLog.shift());
            }
          }
        }, function (error) {
          if (error.name == "CancellationError") return;

          if (error.statusCode === 401 && error.message.toLowerCase() === "invalid token") {
            if (!isGettingNewToken) {
              var auth = getState().auth;

              if (auth.refreshToken) {
                var email = JSON.parse(_jsBase.Base64.decode(auth.token.split('.')[1])).email;
                var token = auth.token;
                var refreshToken = auth.refreshToken;

                dispatch(authActions.refreshLogin({ email: email, token: token, refreshToken: refreshToken }));

                isGettingNewToken = true;
                pendingActionsLog.push(action);
              } else if (auth.token) {
                dispatch(authActions.logout(true));
              }
            } else {
              pendingActionsLog.push(action);
            }

            return;
          }

          if (error.statusCode === 400 && error.code === "RefreshNotPossible") {
            isGettingNewToken = false;
            dispatch(authActions.logout(true));

            // drain the pending actions log now without a token
            while (pendingActionsLog.length) {
              dispatch(pendingActionsLog.shift());
            }
          }

          next((0, _extends3.default)({}, rest, { error: error, type: FAILURE }));
        });

        return actionPromise;
      };
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/clientMiddleware.js
// module id = 1814
// module chunks = 0